import React from "react";
import PageHeader from "../../Molecules/PageHeader/PageHeader";

export const NotFound = () => {
  return (
    <>
    <PageHeader withTitle titleBanner="Página no encontrada" spanTitleYellow="404" />
      <div className="max-width">
        <h2 className="t2 center-text pt-50 pb-50">Error 404 - Página no encontrada</h2>
    </div>
    </>
  )
}
